import { z } from "zod";

export const GoalCodeSchema = z.enum([
  "energy",
  "joy",
  "calm",
  "connection",
  "meaning",
  "alone_time",
]);
export type GoalCode = z.infer<typeof GoalCodeSchema>;

export const LifeSituationSchema = z.enum([
  "working",
  "studying",
  "parental_leave",
  "parent_of_small_children",
  "between_jobs",
  "retired",
  "other",
  "prefer_not_to_say",
]);
export type LifeSituation = z.infer<typeof LifeSituationSchema>;

/** How the user prefers to pursue joy/calm: with others, alone, or both. */
export const PathwayStyleSchema = z.enum(["social", "solo", "both"]);
export type PathwayStyle = z.infer<typeof PathwayStyleSchema>;

export const CoachToneSchema = z.enum([
  "warm_encouraging",
  "direct_practical",
  "reflective_calm",
]);
export type CoachTone = z.infer<typeof CoachToneSchema>;

export const AvailableMinutesSchema = z.enum(["2", "5", "10", "15+"]);
export type AvailableMinutes = z.infer<typeof AvailableMinutesSchema>;

export const PreferredTimeSchema = z.enum([
  "morning",
  "lunch",
  "afternoon",
  "evening",
  "varies",
]);
export type PreferredTime = z.infer<typeof PreferredTimeSchema>;

export const OnboardingStateSchema = z.object({
  step: z.number().int().min(0).max(9),
  goals: z.array(GoalCodeSchema).max(3),
  /** Multi life situations (1–3), or prefer_not_to_say alone */
  lifeSituations: z.array(LifeSituationSchema).max(3).default([]),
  /** @deprecated use lifeSituations — kept for older clients */
  lifeSituation: LifeSituationSchema.optional(),
  joyPathway: PathwayStyleSchema.optional(),
  calmPathway: PathwayStyleSchema.optional(),
  baseline: z
    .object({
      wellbeing: z.number().int().min(0).max(10),
      energy: z.number().int().min(0).max(10),
      stress: z.number().int().min(0).max(10),
      connection: z.number().int().min(0).max(10),
      recovery: z.number().int().min(0).max(10),
      meaning: z.number().int().min(0).max(10),
    })
    .optional(),
  availableMinutes: AvailableMinutesSchema.optional(),
  coachTone: CoachToneSchema.optional(),
  preferredTime: PreferredTimeSchema.optional(),
  notificationsEnabled: z.boolean().optional(),
  completed: z.boolean().default(false),
});

export type OnboardingState = z.infer<typeof OnboardingStateSchema>;

/** Goals that need a pathway follow-up question */
export function goalsNeedPathway(goals: GoalCode[]): {
  joy: boolean;
  calm: boolean;
} {
  return {
    joy: goals.includes("joy"),
    calm: goals.includes("calm"),
  };
}
